import axios from './axios';
import qs from "qs";

function service(endpoint) {

    function fetchSupportedLanguages() {
        return axios.get(`${endpoint}/supported-languages`).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function fetchTranslationsOfKey(data) {
        return axios.get(`${endpoint}/translations-of-key`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        fetchSupportedLanguages,
        fetchTranslationsOfKey
    }
}

export default service
